import cloneDeep from 'lodash/cloneDeep';
import mapKeys from 'lodash/mapKeys';
import upperFirst from 'lodash/upperFirst';
import chartUtils from './chart-utils';
import constants from '../highcharts/constants';

var configNormalizeSeries = function configNormalizeSeries(config, seriesType, seriesName) {
	config.Tooltip = config.CompoundTipField;
	config.SeriesType = seriesType;
	config.SeriesName = seriesName;

	switch (seriesType.toLowerCase()) {
		case 'packedbubble':
			config.FieldName = config.AreaValueField;
			config.LabelField = config.AreaNameField;
			break;
		case 'sankey':
		case 'treemap':
			config.FieldName = config.ValueFieldName;
			break;
		case 'heatmap':
			config.FieldName = config.ValueField;
			config.LabelField = config.RowField;
			break;
		case 'funnelchart':
		case 'pyramidchart':
			config.FieldName = config.XAxisField;
			config.LabelField = config.ValueField;
			break;
		case 'solidgauge':
		case 'gaugeseries':
			config.FieldName = config.NameField;
			config.LabelField = config.ValueField;
			break;
		default:
			break;
	}

	if (!(seriesType.toLowerCase() === 'funnelchart' || seriesType.toLowerCase() === 'pyramidchart')) {
		if (config.Tooltip) {
			var tooltipConfigs = config.Tooltip.TooltipConfigs;

			var configs = tooltipConfigs.map(function (tipItem) {
				return mapKeys(tipItem, function (value, key) {
					return upperFirst(key);
				});
			});

			config.Tooltip.TooltipConfigs = configs;
		}
	}
	return config;
};

var normalizeSeries = function normalizeSeries(widgetConfig, seriesDataObj) {
	var ChartConfig = widgetConfig.ChartConfig,
	    BubbleChartConfig = widgetConfig.BubbleChartConfig,
	    FlowConfig = widgetConfig.FlowConfig,
	    HeatmapConfig = widgetConfig.HeatmapConfig,
	    GaugeConfig = widgetConfig.GaugeConfig,
	    TreemapConfig = widgetConfig.TreemapConfig,
	    XRangeConfig = widgetConfig.XRangeConfig;


	if (!(ChartConfig || BubbleChartConfig || GaugeConfig || FlowConfig || HeatmapConfig || TreemapConfig || XRangeConfig)) return;
	var normalizedSeries = [];

	if (BubbleChartConfig) {
		var config = cloneDeep(BubbleChartConfig);
		normalizedSeries.push(configNormalizeSeries(config, 'packedbubble', 'Packed Bubble'));
		return normalizedSeries;
	} else if (FlowConfig) {
		var _config = cloneDeep(FlowConfig);
		normalizedSeries.push(configNormalizeSeries(_config, 'sankey', 'Sankey'));
		return normalizedSeries;
	} else if (TreemapConfig) {
		var _config2 = cloneDeep(TreemapConfig);
		normalizedSeries.push(configNormalizeSeries(_config2, 'treemap', 'Treemap'));
		return normalizedSeries;
	} else if (GaugeConfig) {
		var _config3 = cloneDeep(GaugeConfig);
		if (GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.SOLIDGAUGE) {
			normalizedSeries.push(configNormalizeSeries(_config3, 'SolidGauge', 'Solid Gauge'));
			return normalizedSeries;
		} else if (GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.GAUGESERIES) {
			normalizedSeries.push(configNormalizeSeries(_config3, 'GaugeSeries', 'Gauge Series'));
			return normalizedSeries;
		}
	} else if (HeatmapConfig) {
		var _config4 = cloneDeep(HeatmapConfig);
		normalizedSeries.push(configNormalizeSeries(_config4, 'heatmap', 'Heatmap'));
		return normalizedSeries;
	} else if (XRangeConfig) {
		var _config5 = cloneDeep(XRangeConfig);
		normalizedSeries.push(configNormalizeSeries(_config5, 'xrange', 'X-range'));
		return normalizedSeries;
	}

	var Series = ChartConfig.Series;

	//for pies and other chart types that do not specify individual series configs

	if (!Series) {
		var _config6 = cloneDeep(ChartConfig);
		_config6.SeriesType = ChartConfig.ChartType.toLowerCase() === constants.chartTypes.FUNNEL ? 'FunnelChart' : ChartConfig && ChartConfig.ChartType.toLowerCase() === constants.chartTypes.PYRAMID ? 'PyramidChart' : _config6.ChartType;
		_config6.FieldName = _config6.ValueField;
		_config6.SeriesName = ChartConfig.ChartType.toLowerCase() === constants.chartTypes.FUNNEL ? 'FunnelChart' : ChartConfig && ChartConfig.ChartType.toLowerCase() === constants.chartTypes.PYRAMID ? 'PyramidChart' : 'Pie';

		if (_config6.Tooltip && _config6.Tooltip.TooltipConfigs.length > 0) _config6.Tooltip.TooltipConfigs = chartUtils.getUpperFirst(_config6.Tooltip.TooltipConfigs);
		normalizedSeries.push(_config6);

		return normalizedSeries;
	}

	normalizedSeries = Series.reduce(function (acc, seriesConfig, index, Series) {
		if (!seriesDataObj) return acc;
		if (seriesConfig.StackOnField) {
			var _SeriesName = seriesConfig.SeriesName,
			    SubSeries = seriesConfig.SubSeries;


			var fields = [_SeriesName].concat(SubSeries && SubSeries.length ? SubSeries.map(function (s) {
				return s.SeriesName;
			}) : []);
			var keys = Object.keys(seriesDataObj).filter(function (k) {
				return fields.includes(k);
			});

			keys.sort(function (a, b) {
				return a.localeCompare(b);
			});
			keys.reverse().forEach(function (key, i) {
				var config = cloneDeep(seriesConfig);
				config.SeriesName = key;
				config.StackName = _SeriesName;
				config.Color = undefined;
				config.StackIndex = keys.length - (i + 1);
				acc.push(config);
			});

			return acc;
		}

		if (seriesConfig.SubSeries && seriesConfig.SubSeries.length > 0) {
			var baseSeries = cloneDeep(seriesConfig);
			baseSeries.StackName = widgetConfig.Name + index; //Use the widget name and the primary series index as the stack name to make sure that it is unique.
			baseSeries.StackIndex = 1;
			acc.push(baseSeries);

			seriesConfig.SubSeries.forEach(function (key, i) {
				var config = cloneDeep(seriesConfig.SubSeries[i]);
				if (seriesDataObj[config.SeriesName]) {
					config.StackName = widgetConfig.Name + index; //Use the widget name and the primary series index as the stack name to make sure that it is unique.
					config.StackIndex = i + 2; //0 based index + 1 + 1 more for base series.
					acc.push(config);
				}
			});

			return acc;
		}

		var SeriesName = seriesConfig.SeriesName;

		var data = seriesDataObj[SeriesName];

		//If the current series is for a trend line include it in the
		//normalized set. The trend line data will be calculated later.
		if (seriesConfig.IsTrendLine) acc.push(seriesConfig);

		//only worry about the series if we have data for it, otherwise don't add it to our normalized series array
		if (data) acc.push(seriesConfig);

		return acc;
	}, []);

	//because sometimes the keys are camelCase and sometimes the keys are PascalCase
	normalizedSeries.forEach(function (seriesConfig) {
		if (!seriesConfig.Tooltip) return;

		var tooltipConfigs = seriesConfig.Tooltip.TooltipConfigs;
		var configs = chartUtils.getUpperFirst(tooltipConfigs);
		seriesConfig.Tooltip.TooltipConfigs = configs;
	});

	return normalizedSeries;
};

export default normalizeSeries;